const ACTIVE_SENSORS_URL = process.env.API_URL + '/xugarhero/sensor/user';

const activeSensor = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(ACTIVE_SENSORS_URL).then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

const activeSensorPrescriptor = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(ACTIVE_SENSORS_URL+'/my-patients').then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

export default{
  activeSensor,
  activeSensorPrescriptor
};



// WEBPACK FOOTER //
// ./src/brand/health/api/activeSensorUsers/index.js